/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Redeemdialog_Description1Inputs */

const id_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic memproses satu Offer gratis per checkout. Pilih game yang ingin Anda tukarkan.`)
};

const ms_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic memproses satu Offer percuma setiap checkout. Pilih permainan yang ingin anda tebus.`)
};

const da_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic behandler én gratis Offer pr. bestilling. Vælg det spil, du vil indløse.`)
};

const de_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic verarbeitet ein kostenloses Angebot pro Kaufvorgang. Wähle das Spiel aus, das du einlösen möchtest.`)
};

const en_us2_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic processes one free Offer per checkout. Select the game you want to redeem.`)
};

const es_es2_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic tramita una oferta gratuita por compra. Elige el juego que quieres canjear.`)
};

const es_mx2_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic tramita una oferta gratuita por compra. Elige el juego que quieres canjear.`)
};

const fil_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang Epic ay nagpoproseso ng isang libreng Offer bawat checkout. Piliin ang larong gusto mong i-redeem.`)
};

const fr_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic ne traite qu'une offre gratuite par commande. Sélectionnez le jeu que vous souhaitez récupérer.`)
};

const it_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic elabora un'offerta gratuita per acquisto. Scegli il gioco che vuoi riscattare.`)
};

const hu_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Epic fizetésenként egy ingyenes Offert dolgoz fel. Válaszd ki a játékot, amelyet be szeretnél váltani.`)
};

const nl_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic verwerkt één gratis Offer per bestelling. Selecteer de game die je wilt inwisselen.`)
};

const no_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic behandler én gratis Offer per utsjekking. Velg spillet du vil løse inn.`)
};

const pl_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic przetwarza jedną darmową Offer na transakcję. Wybierz grę, którą chcesz odebrać.`)
};

const pt_br2_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Epic processa uma oferta gratuita por compra. Selecione o jogo que deseja resgatar.`)
};

const pt_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Epic processa uma oferta gratuita por compra. Seleciona o jogo que queres resgatar.`)
};

const ro_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic procesează o singură ofertă gratuită per checkout. Selectează jocul pe care dorești să îl revendici.`)
};

const fi_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic käsittelee yhden ilmaisen Offerin kassalla. Valitse peli, jonka haluat lunastaa.`)
};

const sv_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic hanterar en gratis Offer per beställning. Välj det spel du vill lösa in.`)
};

const vi_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic xử lý một Offer miễn phí cho mỗi lần thanh toán. Hãy chọn game bạn muốn đổi.`)
};

const tr_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic, ödeme başına yalnızca bir ücretsiz Offer işler. Kullanmak istediğiniz oyunu seçin.`)
};

const cs_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic zpracovává jednu bezplatnou Offer na jednu transakci. Vyberte hru, kterou chcete uplatnit.`)
};

const bg_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic обработва една безплатна Offer на плащане. Изберете играта, която искате да вземете.`)
};

const ru_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic обрабатывает одно бесплатное предложение за одну транзакцию. Выберите игру, которую хотите забрать.`)
};

const uk_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic обробляє одну безплатну Offer за одну транзакцію. Виберіть гру, яку хочете отримати.`)
};

const ar_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعالج Epic Offerًا مجانيًا واحدًا لكل عملية دفع. اختر اللعبة التي تريد استلامها.`)
};

const hi_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic प्रत्येक चेकआउट में एक मुफ़्त Offer संसाधित करता है। वह गेम चुनें जिसे आप प्राप्त करना चाहते हैं।`)
};

const th_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic จะดำเนินการ Offer ฟรีเพียงรายการเดียวต่อการชำระเงิน เลือกเกมที่คุณต้องการรับ`)
};

const ja_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epicは1回のチェックアウトにつき1件の無料Offerを処理します。受け取りたいゲームを選択してください。`)
};

const zh_cn2_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic每次结账仅处理一个免费Offer。请选择您想要领取的游戏。`)
};

const zh_hant1_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic每次結帳僅處理一個免費Offer。請選擇您想要領取的遊戲。`)
};

const ko_freebies_redeemdialog_description1 = /** @type {(inputs: Freebies_Redeemdialog_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic은 결제당 하나의 무료 Offer를 처리합니다. 받고 싶은 게임을 선택하세요.`)
};

/**
* | output |
* | --- |
* | "Epic processes one free Offer per checkout. Select the game you want to redeem." |
*
* @param {Freebies_Redeemdialog_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_redeemdialog_description1 = /** @type {((inputs?: Freebies_Redeemdialog_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Redeemdialog_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_redeemdialog_description1(inputs)
	if (locale === "ms") return ms_freebies_redeemdialog_description1(inputs)
	if (locale === "da") return da_freebies_redeemdialog_description1(inputs)
	if (locale === "de") return de_freebies_redeemdialog_description1(inputs)
	if (locale === "en-US") return en_us2_freebies_redeemdialog_description1(inputs)
	if (locale === "es-ES") return es_es2_freebies_redeemdialog_description1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_redeemdialog_description1(inputs)
	if (locale === "fil") return fil_freebies_redeemdialog_description1(inputs)
	if (locale === "fr") return fr_freebies_redeemdialog_description1(inputs)
	if (locale === "it") return it_freebies_redeemdialog_description1(inputs)
	if (locale === "hu") return hu_freebies_redeemdialog_description1(inputs)
	if (locale === "nl") return nl_freebies_redeemdialog_description1(inputs)
	if (locale === "no") return no_freebies_redeemdialog_description1(inputs)
	if (locale === "pl") return pl_freebies_redeemdialog_description1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_redeemdialog_description1(inputs)
	if (locale === "pt") return pt_freebies_redeemdialog_description1(inputs)
	if (locale === "ro") return ro_freebies_redeemdialog_description1(inputs)
	if (locale === "fi") return fi_freebies_redeemdialog_description1(inputs)
	if (locale === "sv") return sv_freebies_redeemdialog_description1(inputs)
	if (locale === "vi") return vi_freebies_redeemdialog_description1(inputs)
	if (locale === "tr") return tr_freebies_redeemdialog_description1(inputs)
	if (locale === "cs") return cs_freebies_redeemdialog_description1(inputs)
	if (locale === "bg") return bg_freebies_redeemdialog_description1(inputs)
	if (locale === "ru") return ru_freebies_redeemdialog_description1(inputs)
	if (locale === "uk") return uk_freebies_redeemdialog_description1(inputs)
	if (locale === "ar") return ar_freebies_redeemdialog_description1(inputs)
	if (locale === "hi") return hi_freebies_redeemdialog_description1(inputs)
	if (locale === "th") return th_freebies_redeemdialog_description1(inputs)
	if (locale === "ja") return ja_freebies_redeemdialog_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_redeemdialog_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_redeemdialog_description1(inputs)
	return ko_freebies_redeemdialog_description1(inputs)
});
export { freebies_redeemdialog_description1 as "freebies.redeemDialog.description" }